import * as RadixPopover from '@radix-ui/react-popover';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface PopoverProps {
  trigger: ReactNode;
  children: ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  /** Width in px. Default 280. */
  width?: number;
  /** Mono title strip above the content. */
  title?: string;
  /** Accessible name of the popover panel (role=dialog). */
  label?: string;
  /** Render the children edge to edge (lists, command menus) instead of inside the padded body. */
  flush?: boolean;
  className?: string;
}

/** Radix Popover: hairline panel, no shadow, no arrow. */
export function Popover({ trigger, children, open, defaultOpen, onOpenChange, side = 'bottom', align = 'start', width = 280, title, label, flush = false, className }: PopoverProps) {
  return (
    <RadixPopover.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content side={side} align={align} sideOffset={4} collisionPadding={8} style={{ width }} aria-label={label} className={cn('z-[95] rounded-sm border border-line bg-panel text-ink outline-none', className)}>
          {title ? <p className="label-mono border-b border-hair px-3 py-2">{title}</p> : null}
          {flush ? children : <div className="px-3 py-3 text-nav leading-snug">{children}</div>}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}

export const PopoverClose = RadixPopover.Close;
